import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { FetchError, Modal } from "components/molecules";
import {
  CalenderIcon,
  CloseIcon,
  DeleteIcon,
  Spinner,
} from "components/atoms/Icon";
import { Button, Typography } from "components/atoms";
import { YellowClock } from "components/atoms/Icon/YellowClock";
import { Select } from "components/atoms/Icon/Select";
import { EmptyCircle } from "components/atoms/Icon/EmptyCircle";
import { DatePicker } from "components/molecules/DatePicker";
import { formatToLocalDate } from "utils/functions/formatToLocalDate";
import classNames from "classnames";
import {
  useDeleteEventMutation,
  useGetStudyPlannerEventQuery,
  useGetStudyPlannerEventsQuery,
  useGetStudyPlannerFormQuery,
} from "services/studyPlanner";
import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";
import { formatDateDuration } from "utils/functions/formatDateDuration";
import { ErrorModal } from "./ErrorModal";
import { mixpanelHelper } from "utils/functions/mixPanelHelper";
import { decodeToken } from "utils/functions/decodeToken";
import "./study-modal.scss";
import { DrillModal } from "components/organisms/TabClassHomeWork";
import { replaceArrayOfObjects, reStructureSegment } from "utils/functions/courseWorkReStructure";
import { useGetCourseworkQuery, useGetOverallProgressQuery, useGetTestScoresAndPerformanceQuery } from "services/homeApi";
import { useLazyGetCourseIndexQuery } from "services/courseIndex";
import { getObjectKeysByValue } from "services/helpers";
import { getTimeFilterInput } from "utils/functions/getTimeFilterInput";
import { useSegmentReFetch } from "context";
import { openExternalUrl } from "utils/functions/openExternalUrl";
import { useAppDispatch } from "hooks";

dayjs.extend(utc);

interface IProps {
  isOpen: boolean;
  handleOnclose: any;
  type: any;
  theme: "light" | "dark";
  currentState: any;
  validateRescheduleDate: any;
  isDelete: boolean;
  setOpenRefreshModal?: Dispatch<SetStateAction<any>>;
  setIsDelete: Dispatch<SetStateAction<boolean>>;
  handleSetCourseworkPage: (data: any) => void;
  courseworkPage: number;
}

export const StudyModal = ({
  isOpen,
  handleOnclose,
  type,
  theme,
  currentState,
  validateRescheduleDate,
  isDelete,
  setOpenRefreshModal,
  setIsDelete,
  handleSetCourseworkPage,
  courseworkPage
}: IProps) => {
  const { refetch: refetchGetStudyPlannerEvent, isLoading, isFetching, isError, data, error }: any =
    useGetStudyPlannerEventQuery(
      {
        eventId: currentState.eventId,
      },
      {
        skip:
          currentState.eventId === undefined || currentState.eventId === null,
      }
    );

  const { refetch: refetchAllEvents, isFetching: isFetchingEvents } =
    useGetStudyPlannerEventsQuery();

  const { data: formData } = useGetStudyPlannerFormQuery();

  const [deleteItem, { isLoading: isLoadingDelete, isError: isErrorDelete }] =
    useDeleteEventMutation();

  const dispatch = useAppDispatch();
  const payload = decodeToken();

  const userId = payload ? payload.userid : null;
  const productCode = payload ? payload.productcode : null;
  const offeringCode = payload ? payload.offeringcode : null;
  const testtype = payload?.testtype;

  const {
    refetch: overAllProgressRefetch,
  } = useGetOverallProgressQuery({
    Userid: userId,
    Productcode: productCode,
    Offeringcode: offeringCode,
  });

  const { data: courseworkData, setData, selectedBtn, selectedSession } = useSegmentReFetch();

  const [ triggerCourseIndexRefetch ] = useLazyGetCourseIndexQuery();

  const { refetch: testScoresRefetch } =
    useGetTestScoresAndPerformanceQuery();

  const { refetch: courseWorkRefetch } =
    useGetCourseworkQuery({
      page: courseworkPage,
      selectedOption: parseInt(
        getObjectKeysByValue(selectedBtn, true)[0],
        10
      ),
      timeFilter:
        selectedSession === null
          ? 1
          : getTimeFilterInput(Object.values(selectedSession)[0]),
    });


  // const [isShowDeleteModal, setIsShowDeleteModal] = useState<boolean>(false);
  const [isDateChange, setIsDateChange] = useState<boolean>(false);
  const [pickDate, setPickDate] = useState<string>();

  const [openUpdateModalState, setOpenUpdateModalState] = useState<any>({
    isOpen: false,
    data: null,
  });

  const handleReschedule = (date: any) => {
    const formatDate = date.format("YYYY-MM-DD");
    validateRescheduleDate(data, formatDate);
    handleOnclose();
  };

  const handleDeleteItem = async (id: number) => {
    try {
      await deleteItem({ eventId: id })
        .unwrap()
        .then(() => handleOnclose());
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleDeleteModalPopUp = (isDelete: boolean) => {
    setIsDelete((prev) => isDelete);
  };

  const handleItemClick = (obj: any) => {
    if (
      obj.ContentObjectType === "OfflineDrill" ||
      obj.ContentObjectType === "OfflineReading"
    ) {
      setOpenUpdateModalState((prev: any) => ({
        ...prev,
        isOpen: true,
        data: obj,
      }));
      handleSetCourseworkPage && handleSetCourseworkPage(data);
      // window.open(obj.LaunchUrl, "__blank");
      // handleOnclose();
      // setOpenRefreshModal &&
      //   setOpenRefreshModal((prev: any) => ({
      //     ...prev,
      //     isOpen: true,
      //     contentObjectType: obj.ContentObjectType,
      //     eventId: currentState.eventId,
      //   }));
    } else {
      handleSetCourseworkPage && handleSetCourseworkPage(data);
      openExternalUrl({
        url: obj.LaunchUrl,
        contentObjectType: obj.ContentObjectType,
        testType: testtype,
        dispatch,
        onRefreshModalOpen: (contentType) => {
          setOpenRefreshModal?.((prev: any) => ({
            ...prev,
            isOpen: true,
            contentObjectType: contentType || obj.ContentObjectType,
            eventId: currentState.eventId,
          }));
        },
      });
      handleOnclose();
    }
  };

  const handleUpdateModalClose = () => {
    setOpenUpdateModalState((prev: any) => ({
      ...prev,
      isOpen: false,
      data: null,
    }));
  };

  const handleRefetchData = () => {
    const promises = [
      courseWorkRefetch(),
      refetchAllEvents(),
      overAllProgressRefetch(),
      refetchGetStudyPlannerEvent(),
      testScoresRefetch(),
      triggerCourseIndexRefetch()
    ];
    Promise.allSettled(promises).then((responses: any) => {
      if (responses[0].status === "fulfilled") {
        const deStructuredArray = reStructureSegment(responses[0].value.data);
        const updatedArray = replaceArrayOfObjects(deStructuredArray, courseworkData);
        setData([...updatedArray]);
      }
    });
    handleUpdateModalClose();
  };

  const handleResetOnCancel = () => {
    setPickDate(data && data.ScheduledDate);
  };

  useEffect(() => {
    if (data) {
      mixpanelHelper.track("View Study Plan Event", {
        startDate: formData.StartDate,
        endDate: formData.ExamDate,
        plannedWeeklyStudyTime: formData.HoursPerWeek,
        segmentID: currentState.cardData.StudyPlannerEventId,
        segmentDescription: currentState.cardData.Title,
        duration: data.TimeEstimate,
        instructorID: "",
        courseProgress: `${Math.round((currentState.cardData.GroupingItemsCountComplete / currentState.cardData.GroupingItemsCount) * 100)}%`,
        scheduledDate: data.ScheduledDate,
        dueDate: "",
        finalExamDate: formData.ExamDate,
        testType: data.TestType,
        productCode: productCode,
        psoCode: offeringCode,
        userID: userId,
      });
    }
  }, [data]);

  useEffect(() => {
    setPickDate(data && data.ScheduledDate);
  }, [data, isOpen]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={handleOnclose}
        theme={theme}
        style="study-modal-customize-custom-style"
      >
        {isLoading || isFetching ? (
          <div className="indicator-wrapper">
            <Spinner theme={theme} />
          </div>
        ) : isError || isErrorDelete ? (
          error && error.data ? (
            <ErrorModal
              handleOnclose={handleOnclose}
              message={error.data.Message}
            />
          ) : (
            <div className="indicator-wrapper">
              <FetchError content="Oops! failed to load resources." />
            </div>
          )
        ) : (
          data && (
            <>
              <div
                className={classNames({
                  "study-modal-header-wrapper": true,
                  "diagnostic-exam": type === "Diagnostic",
                  "homework-tile": type === "Homework",
                  "additional-header":
                    type !== "Homework" &&
                    type !== "Diagnostic" &&
                    type !== "TestSegment" &&
                    type !== "ClassSegment" &&
                    type !== "TestDay" &&
                    type !== "Prework",
                })}
              >
                <CloseIcon
                  theme={theme}
                  style="study-modal-close-icon"
                  onClick={handleOnclose}
                  color={theme === "light" ? "#9D9D9D" : "white"}
                />
                <div className="header-content-wrapper">
                  <div className="left-section">
                    <Typography
                      label={data.Title}
                      styles="title-text"
                      variant="h7Bold"
                    />
                    {type === "Homework" ||
                    type === "Diagnostic" ||
                    type === "Prework" ? (
                      <Typography
                        label={data.EventType.replace(/([A-Z])/g, " $1").trim()}
                        styles="subtitle-text"
                        variant="h8Med"
                      />
                    ) : null}
                    <Typography
                      label={`aprox: ${
                        data.TimeEstimate === 0 || data.TimeEstimate === null
                          ? "0 min"
                          : formatDateDuration(data.TimeEstimate)
                      }`}
                      variant="h9Medium"
                      styles="time-text"
                    />
                  </div>
                  <div className="right-section">
                    <Typography
                      label="Scheduled Date"
                      styles="date-label"
                      variant="h8Med"
                    />
                    <div className="date-wrapper">
                      {/* <Typography
                      label={dayjs
                        .utc(data.ScheduledDate)
                        .local()
                        .format("MM/DD/YYYY")}
                      variant="h8Book"
                    />
                    <CalenderIcon
                      color={theme === "light" ? "black" : "white"}
                    /> */}
                      {/* <DatePicker/> */}
                      <DatePicker
                        setDateSelection={setPickDate}
                        defaultSelected={pickDate}
                        placeholder={dayjs(data.ScheduledDate).format(
                          "MM/DD/YYYY"
                        )}
                        inputFormat={"MM/DD/YYYY"}
                        isStudyTimer
                        handleReschedule={handleReschedule}
                        resetOnCancel={handleResetOnCancel}
                      />
                    </div>
                  </div>
                  {data && data.IsDelitable === true ? (
                    <DeleteIcon
                      // onClick={() => handleDeleteItem(data.StudyPlannerEventId)}
                      onClick={() => handleDeleteModalPopUp(true)}
                    />
                  ) : null}
                </div>
              </div>
              <div className="study-modal-body-wrapper">
                {data.Items.map((obj: any, index: number) => (
                  <div key={index} className="item-wrapper">
                    {obj.Status === "Inprogress" ||
                    obj.Status === "InProgress" ||
                    obj.Status === "In-Progress" ? (
                      <div className="icon-wrapper">
                        <YellowClock />
                      </div>
                    ) : obj.Status === "Complete" ||
                      obj.Status === "Completed" ? (
                      <div className="icon-wrapper">
                        <Select />
                      </div>
                    ) : obj.Status === "Todo" || obj.Status === "Pending" ? (
                      <div className="icon-wrapper">
                        <EmptyCircle theme={theme} />
                      </div>
                    ) : (
                      <div className="icon-wrapper">
                        <Select />
                      </div>
                    )}
                    <Typography
                      variant="h8Med"
                      label={obj.Title}
                      onClick={() => handleItemClick(obj)}
                      styles="launch-item-text"
                    />
                  </div>
                ))}

                {data && isDelete ? (
                  <div className="delete-section">
                    <div className="typo-section">
                      <Typography
                        label="Are you sure you want to delete this item?"
                        variant="h8Med"
                      />
                    </div>
                    <div className="btn-section">
                      <Button
                        icon={false}
                        label="Cancel"
                        type="online"
                        onClick={() => handleDeleteModalPopUp(false)}
                      />
                      <Button
                        icon={false}
                        label="Delete"
                        type="score"
                        isLoading={isLoadingDelete}
                        onClick={() =>
                          handleDeleteItem(data.StudyPlannerEventId)
                        }
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            </>
          )
        )}
      </Modal>
      <DrillModal
        handleUpdateModalClose={handleUpdateModalClose}
        openUpdateModalState={openUpdateModalState}
        refetchData={handleRefetchData}
        theme={theme}
        isFetchingOtherAPIs={isFetching || isFetchingEvents}
      />
    </>
  );
};
